<template>
  <div class="new-pro">
    <v-container fluid>
      <div class="text-new-pro">
        <h3 class="pt-15 text-pro">new products</h3>
      </div>
      <a
        href="#"
        class="text-black pt-5"
        style="font-size: 14px; text-align: end; display: block"
        >Shop All</a
      >

      <v-row>
        <v-col cols="12" md="6" class="order-1">
          <template v-if="!datawoman.length">
            <v-row>
              <v-col class="pt-10" cols="5" v-for="num in 2" :key="num">
                <v-skeleton-loader type="image, article"></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>

          <swiper
            v-else
            :slides-per-view="2"
            :space-between="30"
            :pagination="{ clickable: true }"
            :modules="modules"
            :navigation="true"
            class="mySwiper pb-5"
            style="padding-top: 10px"
            :autoplay="{ delay: 3000 }"
            :breakpoints="breakpoints"
          >
            <swiper-slide v-for="item in datawoman" :key="item.id">
              <v-card elevation="0" class="pb-10 text-center">
                <div class="master" style="position: relative">
                  <img
                    :src="item.image"
                    class="w-100"
                    style="height: 180px"
                    alt=""
                  />
                  <v-btn
                    @click="openView(item)"
                    density="compact"
                    width="60"
                    height="30"
                    variant="outlined"
                    class="bg-white quick-viewF"
                  >
                    Quick View
                  </v-btn>
                </div>

                <v-card-text class="pa-0">
                  <span style="font-weight: bold">
                    ({{
                      item.title.split(" ").length <= 4
                        ? item.title
                        : item.title.split(" ").slice(0, 4).join(" ")
                    }})</span
                  >
                  {{
                    item.description.split(" ").length <= 4
                      ? item.description
                      : item.description.split(" ").slice(0, 4).join(" ") +
                        "....."
                  }}
                </v-card-text>
                <v-rating
                  v-model="item.rating.rate"
                  half-increments
                  readonly
                  color="yellow-darken-2"
                  size="x-small"
                  density="compact"
                ></v-rating>
                <v-card-text class="pt-0">
                  <span style="font-weight: 700; margin-right: 2px">From</span>
                  <span
                    style="font-size: 16px; font-weight: 900; color: #ff0000"
                  >
                    {{ item.price }}$
                  </span>
                </v-card-text>

                <div class="mt-5">
                  <v-btn
                    @click="
                      router.push({
                        name: 'product-detils',
                        params: { productId: item.id },
                        query: { name: 'woman' },
                      })
                    "
                    color="red"
                    variant="outlined"
                    style="
                      text-transform: none;
                      border-radius: 30px;
                      padding: 10px 20px;
                      font-weight: 700;
                      font-size: 13px;
                    "
                  >
                    Choose Options
                  </v-btn>
                </div>
              </v-card>
            </swiper-slide>
            <div class="swiper-pagination"></div>
          </swiper>
        </v-col>
        <v-col cols="12" md="6">
          <div class="imge-new-pro">
            <img src="../../images/vr-banner.webp" class="w-100" alt="" />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style lang="css">
.new-pro .text-new-pro {
  font-weight: 800;
  background: linear-gradient(65deg, #1f0dff, #67d767, #ff0000);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 30px;
  justify-content: center;
}
.master .quick-viewF {
  text-transform: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 30px;
  font-size: 12px;
  transition: 0.2s all ease-in-out;
  opacity: 0;
}
.master:hover .quick-viewF {
  opacity: 1;
}
.new-pro .swiper-button-next:after,
.new-pro .swiper-button-prev:after {
  font-size: 20px;
  background-color: #2196f3;
  padding: 15px 20px;
  color: white;
  font-weight: 900;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 480px) {
  .new-pro .text-pro {
    font-size: 20px;
  }
}
</style>

<script setup>
import { ref, defineProps, onMounted, inject } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay } from "swiper";
import { useRouter } from "vue-router";
const Emitter = inject("Emitter");
const openView = (productId) => {
  Emitter.emit("openView", productId);
};

const router = useRouter();

const breakpoints = ref({
  0: {
    slidesPerView: 1,
  },
  580: {
    slidesPerView: 2,
  },
});

const modules = ref([Pagination, Navigation, Autoplay]);
// استيراد مكونات Swiper

// تعريف الخصائص
const props = defineProps({
  datawoman: Array,
});

// استخدام onMounted لطباعة البيانات في وحدة التحكم عند تحميل المكون
onMounted(() => {
  console.log(props.products);
});
</script>
